/* eslint-disable no-shadow */

const ufeApi = require('services/api/ufeApi');
const updateProfile = require('services/api/profile/updateProfile');

const {
    PROMOTIONAL_EMAILS_PREFS_COUNTRIES,
    PromotionalEmailsPrefsFrequency,
    EmailSubscriptionTypes,
    SubscriptionStatus
} = require('services/api/profile/constants');

function getPromotionalEmailPreferences(userProfileId) {
    const url = `/api/users/profiles/${userProfileId}?` + 'propertiesToInclude=emailSubscriptionInfo';

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => {
        let promise;

        if (data.errorCode) {
            promise = Promise.reject(data);
        } else {
            const subscriptions = data.emailSubscriptionInfo || [];

            const consumerSubs = subscriptions.filter(data => data.subscriptionType === EmailSubscriptionTypes.CONSUMER)[0];

            const emailPrefs = {
                subscribed: (consumerSubs && consumerSubs.subscriptionStatus === SubscriptionStatus.SUBSCRIBED) || false,
                frequency: (consumerSubs && consumerSubs.subscriptionFrequency) || PromotionalEmailsPrefsFrequency.DAILY,
                country: (consumerSubs && consumerSubs.countryLocation) || PROMOTIONAL_EMAILS_PREFS_COUNTRIES[0][0],
                zipPostalCode: (consumerSubs && consumerSubs.subscriptionZip) || null
            };

            promise = Promise.resolve(emailPrefs);
        }

        return promise;
    });
}

function setPromotionalEmailPreferences(userProfileId, prefs) {
    return updateProfile({
        fragmentForUpdate: 'EMAIL_SUBSCRIPTION',
        emailSubscriptionInfo: {
            subScribeToEmails: prefs.subscribed,
            subscriptionType: EmailSubscriptionTypes.CONSUMER,
            countryLocation: prefs.country,
            subscriptionFrequency: prefs.frequency,
            zipCode: prefs.zipPostalCode
        }
    });
}

module.exports = {
    getPromotionalEmailPreferences,
    setPromotionalEmailPreferences
};
